import script from "./Questions.vue?vue&type=script&setup=true&lang=js"
export * from "./Questions.vue?vue&type=script&setup=true&lang=js"

import "./Questions.vue?vue&type=style&index=0&id=461eedd2&scoped=true&lang=scss"

import exportComponent from "/home/nodeapps/vitamins/koningsnvteaching/frontendBuild/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-461eedd2"]])

export default __exports__